import "../../auto-mapper/AutoMapperProvider.js";
import { useAutoMapper } from "../../auto-mapper/hooks.js";
import { PlayerBonus } from "../../contract/pam.js";
import { useBonusCodes } from "../bonus-code/hooks.js";
import { BonusCodeDetailsViewModel } from "../bonus-code/types.js";
import "typesafe-actions";
import "rxjs";
import "rxjs/operators";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "redux-observable";
import "../../api/types.js";
import "immer";
import "moment-timezone";
import "react-intl";
import "@apollo/client/errors";
import "@apollo/client";
import "graphql";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "../../redux-folder/async-action/action.js";
import "../../redux-folder/error-handling/action.js";
import "../../redux-folder/actions.js";
import "fast-deep-equal/es6";
import "redux";
import "../../redux-folder/entity/epics.js";
import "normalizr";
import "../../redux-folder/entity/EntityProvider.js";
import "../../redux-folder/realtime/RealtimeNotification.js";
import "reselect";
import { useViewInit } from "../../redux-folder/view/hooks.js";
import { getNonEmptyValueValidator } from "../../redux-folder/view/utils.js";
import { PlayerBonusViewModelKeysTypeName, PlayerBonusQueryFieldsTypeName } from "./constants.js";
import { PlayerBonusViewModel } from "./types.js";
function usePlayerBonuses({
  viewType,
  fields,
  displayName,
  cleanDelay = 0,
  realtimeMode,
  triggers,
  defaultFilters,
  defaultPaging,
  defaultSorting,
  validateFilter,
  syncWithUrl = false,
  playerBonusEntityType
}, bonusCodeProps) {
  const mapper = useAutoMapper();
  const {
    items: playerBonuses,
    totalCount,
    searchFilter,
    viewEntity: { filter: filterString },
    handlePageChange,
    handlePageSizeChange,
    handleSortChange,
    handleFilterChange
  } = useViewInit({
    viewType,
    displayName,
    entity: {
      entity: playerBonusEntityType,
      fields: mapFields(fields)
    },
    realtime: realtimeMode ? { entity: playerBonusEntityType, mode: realtimeMode, triggers } : null,
    defaultSorting: mapSorting(defaultSorting),
    defaultPaging,
    defaultFilters,
    syncWithUrl,
    validateFilter: validateFilter ?? (() => true),
    cleanDelay
  });
  const { items: bonusCodes, rawItems: bonusCodesRawItems } = useBonusCodes({
    ...bonusCodeProps,
    ids: playerBonuses?.map((i) => i?.bonus_engine_code),
    validateFilter: (filter) => bonusCodeProps?.fields?.length > 0 && getNonEmptyValueValidator("bonusId")(filter)
  });
  const playerBonusesVm = playerBonuses?.map((i) => mapper.tryMap(i, PlayerBonus, PlayerBonusViewModel));
  const items = playerBonusesVm?.map((i) => {
    const bonusCodeIndex = bonusCodes?.findIndex((b) => b?.bonus_id === i.model?.bonus_engine_code);
    const bonusCode = bonusCodes?.[bonusCodeIndex];
    const bonusCodeRaw = bonusCodesRawItems?.[bonusCodeIndex] ?? { isValid: true, raw: "" };
    const result = mapper.tryMutate(bonusCode, i.model, BonusCodeDetailsViewModel, PlayerBonusViewModel);
    return {
      model: result?.model,
      isModelValid: i.isModelValid && result.isModelValid && bonusCodeRaw.isValid,
      rawModelString: [i.rawModelString, bonusCodeRaw.raw].join(",")
    };
  });
  function mapFields(fields2) {
    return mapper?.map(
      fields2,
      PlayerBonusViewModelKeysTypeName,
      PlayerBonusQueryFieldsTypeName
    );
  }
  function mapField(field) {
    return mapFields([field])[0];
  }
  function mapSorting(sorting) {
    return sorting?.map((s) => ({ ...s, field: mapField(s.field) }));
  }
  return {
    items: items?.map((i) => i.model),
    rawItems: items?.map((i) => ({ isValid: i.isModelValid, raw: i.rawModelString })),
    totalCount,
    searchFilter,
    filterString,
    handlePageChange,
    handlePageSizeChange,
    handleSortChange,
    handleFilterChange
  };
}
export {
  usePlayerBonuses
};
//# sourceMappingURL=hooks.js.map
